import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import React from 'react';

type Props = {
  title?: React.ReactNode;
  children?: React.ReactNode;
};

const WarningAlert = ({ title, children }: Props) => {
  return (
    <Alert variant="light" color="yellow" title={title} icon={<IconAlertTriangle />}>
      {children}
    </Alert>
  );
};

export default WarningAlert;
